var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('portal',{attrs:{"to":"pane"}},[_c('transition',{attrs:{"name":"pane-slide"}},[_c('div',{staticClass:"w-96 bg-white shadow-lg fixed inset-y-0 right-0"},[_vm._t("default",null,{"close":_vm.close})],2)])],1)}
var staticRenderFns = []

export { render, staticRenderFns }